import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {AssetEntity} from './asset.entity';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {LayoutAssetGroupXrefEntity} from './layout.asset.group.xref.entity';
import {LayoutLayerXrefEntity} from './layout.layer.xref.entity';

@EntityTable('layout', 'ccac9ef5-7e4f-4028-a4e8-70b1b9ee26ea')
export class LayoutEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.STRING)
    public class: string;

    @Column(FieldTypeKind.ANY)
    public condition: any;

    @Column(FieldTypeKind.ANY)
    public assets: any;

    @Column(FieldTypeKind.ANY)
    public html: any;

    @Column(FieldTypeKind.ANY)
    public context: any;

    @Transient('layout_layer_xref', FieldRelationKind.HAS_MANY, 'layoutId', 'aliasId', 'aliasId')
    public layoutLayerXrefs: LayoutLayerXrefEntity[];

    @Transient('layout_asset_group_xref', FieldRelationKind.HAS_MANY, 'layoutId', 'aliasId', 'aliasId')
    public layoutAssetsXrefs: LayoutAssetGroupXrefEntity[];

    @Transient()
    public faviconAsset: AssetEntity;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

}
